const AboutUsLeftVector = ({ width = 554, height = 770, fill = "#F8EDE3", className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 554 770"
      fill="none"
      className={className}
    >
      <path
        d="M469.062 -132.425L-114.263 168.015C-119.095 170.504 -120.98 176.436 -118.5 181.252L181.94 764.577C184.471 769.491 190.616 771.431 195.48 768.843C517.837 596.804 645.093 199.24 482.555 -128.011C480.098 -132.941 473.968 -134.931 469.071 -132.408L469.062 -132.425Z"
        fill={fill}
      />
    </svg>
  );
};

export default AboutUsLeftVector;
